import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  Divider,
  CardActions,
  Button,
  Typography,
  Avatar,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Tooltip,
  CircularProgress,
  Grid,
  IconButton,
} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import AssignmentsIcon from '../../../../../assets/Images/grade_book_assignments.png';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ControlledSkelton from './ControlledSkelton';

const styles = theme => ({
  margin: {
    margin: theme.spacing(2)
  },
  extendedIcon: {
    marginRight: theme.spacing(2)
  },
  smallAvatar: {
    width: 30,
    height: 30
  },
  actions: {
    justifyContent: 'flex-end',
    textAlign: 'center'
  },
  btnText: {
    fontSize: 15,
    padding: 12,
    textTransform: 'capitalize'
  },
  bigAvatar: {
    width: 40,
    height: 40,
    marginTop: 5,
    borderRadius: 0
  }
});
const Assignements = (props) => {

  const { classes, data, isLoading } = props;

  return (
    <Card className={classes.card}>
      <CardHeader
        title={<Typography color="primary">Assignments</Typography>}
        subheader={"All assignments"}
        avatar={<Avatar className={classes.bigAvatar} src={AssignmentsIcon} />}
        onClick={() => window.location = "#/dashboard/F107Form/0"}
        style={{ cursor: "pointer" }}
      />
      <CardContent
        style={{
          height: 210,
        }}
      >
        <List style={{
          marginTop: '-30px',
          height: 238,
          overflow: "hidden",
        }}>
          {data.length > 0 ?
            data.map((dt, i) => (
              <Fragment key={i}>
                <ListItem
                  style={{ paddingTop: 0 }}
                  alignItems="flex-start"
                >
                  <ListItemAvatar>
                    <Avatar
                      alt="Img"
                      src={AssignmentsIcon}
                      className={classes.smallAvatar}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    onClick={() => window.location = "#/dashboard/F107Form/0"}
                    style={{ cursor: "pointer" }}
                    primary={
                      <Typography
                        component="legend"
                        className={classes.inline}
                        color="textPrimary"
                        style={{
                          flex: 1,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                      >
                        {dt.courseLabel}
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          variant="caption"
                          style={{ paddingLeft: "2px" }}
                        >
                          {/* "DueDate: "+dt.dueDateReport : "Start Date: "+dt.startDateReport} */}
                          {<span>{"Start: " + dt.startDate}<br />{"End: " + dt.endDate}</span>}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                  {dt.isStarted == 1 ? <Tooltip title="Download File">
                    <IconButton
                      onClick={(e) => props.downloadFile(e, dt.fileName)}
                      aria-label="download"
                      disabled={!dt.fileName}
                      color="primary"
                      style={{ marginTop: ".5em" }}
                      size="large">
                      <CloudDownloadIcon />
                    </IconButton>
                  </Tooltip>
                    :
                    <IconButton disabled={true} aria-label="download" size="large">
                      <CloudDownloadIcon />
                    </IconButton>}
                </ListItem>
              </Fragment>
            ))
            :
            isLoading &&
            <Grid container justifyContent="center">
              {/* <CircularProgress /> */}
              <Grid size={12}>
                <ControlledSkelton />
              </Grid>
            </Grid>
          }
        </List>
      </CardContent>
      <Divider variant="middle" />
      <CardActions className={classes.actions}>
        <div>
          <Tooltip title="More">
            <Button className={classes.btnText} color="primary" onClick={() => window.location = "#/dashboard/F107Form/0"}>
              More
            </Button>
          </Tooltip>
        </div>
      </CardActions>
    </Card>
  );
}
Assignements.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  downloadFile: PropTypes.func
}

Assignements.defaultProps = {
  data: [],
  isLoading: false,
  downloadFile: fn => fn
}

export default withStyles(styles)(Assignements);
